import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import { type FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEffectOnce } from '../../../../../../../hooks/use-effect-once';
import { ConfigurationsContainer } from '../../../containers/ConfigurationsContainer';
import { useFetchMorningSettings } from '../hooks/useFetchMorningSettings';
import type {
  MorningConfigurationControl,
  MorningConfigurationFormValues,
} from '../MorningConfigurationFormSchema';
import { CustomerConfigurationSection } from './components/CustomersConfigurationSection';
import { InvoicesConfigurationSection } from './components/InvoicesConfigurationSection';
import { TokenConfigurationSection } from './components/TokenConfigurationSection';

type MorningConfigurationFormProps = {
  control: MorningConfigurationControl;
};

export const MorningConfigurationForm: FC<MorningConfigurationFormProps> = ({ control }) => {
  const { configuration } = useFetchMorningSettings();
  const { reset } = useFormContext<MorningConfigurationFormValues>();

  useEffectOnce(() => {
    reset(configuration);
  });

  return (
    <FormContainer>
      <Typography variant="h5">Configurations</Typography>
      <ConfigurationsContainer>
        <TokenConfigurationSection control={control} defaultValues={configuration} />
        <CustomerConfigurationSection control={control} defaultValues={configuration} />
        <InvoicesConfigurationSection control={control} defaultValues={configuration} />
      </ConfigurationsContainer>
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});